import { useMemo } from "react";
import useSearchStore from "@/stores/useSearchStore";

import { useInfiniteSearch } from "@/hooks/api/search/useInfiniteSearch";
import Form from "@/components/molecules/form/Form";
import SearchResults from "@/components/organisms/search/SearchResults";
import SearchSidebar from "@/components/organisms/search/SearchSidebar";
import StartSearch from "@/components/organisms/search/StartSearch";

const Search = () => {
  const { filter, submitted, submittedFilter, submitFilter, changedCompanyIds } = useSearchStore((state) => state);
  const searchQueryHook = useInfiniteSearch(submittedFilter);

  const flattenedData = useMemo(
    () => searchQueryHook.data?.pages?.flatMap((page) => page.data) ?? [],
    [searchQueryHook.data?.pages],
  );

  const changedCompanies = useMemo(() => {
    if (!flattenedData) return [];
    return flattenedData.filter((company) => changedCompanyIds.includes(company.id));
  }, [changedCompanyIds, flattenedData]);

  return (
    <>
      <Form
        onSubmit={submitFilter}
        defaultValues={filter}
        className="z-50 flex h-screen w-full max-w-72 shrink-0 flex-col overflow-y-auto border-r border-secondary bg-white px-6"
      >
        <SearchSidebar isLoading={searchQueryHook.isLoading} changedCompanies={changedCompanies} />
      </Form>
      {submitted ? <SearchResults searchParams={submittedFilter} searchQueryHook={searchQueryHook} /> : <StartSearch />}
    </>
  );
};

export default Search;
